import { combineReducers } from 'redux';
import activeListings from './activeListings/activeListingsReducer';
import login from './login/loginReducer';
import user from './user/userReducer';
import search from './search/searchReducers';
import open from './openOrders/openOrdersReducer';
import completed from './completedOrders/completedOrdersReducer';
import view from './view/viewReducer';
import cancel from './cancel/cancelReducer';

export default combineReducers({
  activeListings: activeListings,
  openOrders: open,
  completedOrders: completed,
  status: login,
  user: user,
  search: search,
  currentView: view,
  cancel: cancel,
});
